import axios from "@/libs/api.request";
import { jingxiaoshang } from "./api_url";

/**
 * 设备分销管理列表接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_distribution_list = data => {
  let country_code = localStorage.getItem("country_code");

  return axios.request({
    url: jingxiaoshang.device_distribution_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 区域列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const area_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 经销商列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_merchant_all = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_merchant_all,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 分配经销商
 * @param data
 * @returns {*|{responseURL}}
 */
export const allocation_add = data => {
  return axios.request({
    url: jingxiaoshang.allocation_add,
    data: data,
    method: "post"
  });
};

/**
 * 分配详情
 * @param data
 * @returns {*|{responseURL}}
 */
export const allocation_log = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.allocation_log,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const allocation_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.allocation_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取下载token
 * @param data
 * @returns {*|{responseURL}}
 */
export const getdownloadtoken = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getdownloadtoken,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 下载
 * @param data
 * @returns {*|{responseURL}}
 */
export const downloadFile = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.downloadFile,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设备详细信息列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const devicedetail_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.devicedetail_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 启用禁用
 * @param data
 * @returns {*|{responseURL}}
 */
export const handle_fx_status = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_fx_status,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 申诉
 * @param data
 * @returns {*|{responseURL}}
 */
export const appeal = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.appeal,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const did_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.did_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增区域
 * @param data
 * @returns {*|{responseURL}}
 */
export const area_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑区域
 * @param data
 * @returns {*|{responseURL}}
 */
export const area_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除区域
 * @param data
 * @returns {*|{responseURL}}
 */
export const area_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增经销商
 * @param data
 * @returns {*|{responseURL}}
 */
export const merchant_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑经销商
 * @param data
 * @returns {*|{responseURL}}
 */
export const merchant_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 经销商列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const merchant_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除商户
 * @param data
 * @returns {*|{responseURL}}
 */
export const merchant_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 转移
 * @param data
 * @returns {*|{responseURL}}
 */
export const transfer_merchant_parent = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.transfer_merchant_parent,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设备新增激活统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_increate_activation = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_increate_activation,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设备累计上线统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_accumulate_online = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_accumulate_online,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 操作状态
 * @param data
 * @returns {*|{responseURL}}
 */
export const handle_state = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_state,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 告警列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const alarm_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.alarm_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 处理告警
 * @param data
 * @returns {*|{responseURL}}
 */
export const handle_alarm = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_alarm,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 物联网用户列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const iotuser_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotuser_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 查看设备
 * @param data
 * @returns {*|{responseURL}}
 */
export const view_device = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.view_device,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取分类
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_type = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_type,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增字典
 * @param data
 * @returns {*|{responseURL}}
 */
export const dict_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 字典列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const dict_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设置默认
 * @param data
 * @returns {*|{responseURL}}
 */
export const set_default = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_default,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑字典
 * @param data
 * @returns {*|{responseURL}}
 */
export const dict_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 历史记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const history_log = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.history_log,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除历史记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const history_log_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.history_log_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 首页统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_index_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_index_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_device_info = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_device_info,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */
export const dsgetconfigbyuser = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dsgetconfigbyuser,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设置加热膜
 * @param data
 * @returns {*|{responseURL}}
 */
export const set_jrm = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_jrm,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 设置时区
 * @param data
 * @returns {*|{responseURL}}
 */
export const set_timezone = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_timezone,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增计划
 * @param data
 * @returns {*|{responseURL}}
 */
export const dptimetaskadd = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskadd,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 计划列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const dptimetasklist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetasklist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除计划
 * @param data
 * @returns {*|{responseURL}}
 */
export const dptimetaskdel = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskdel,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑计划
 * @param data
 * @returns {*|{responseURL}}
 */
export const dptimetaskedit = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskedit,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */
export const iotconfigset = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotconfigset,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 拉取一级，二级数据
 * @param data
 * @returns {*|{responseURL}}
 */
export const iotdatalastget = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotdatalastget,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 下发命令
 * @param data
 * @returns {*|{responseURL}}
 */
export const web_issue_order = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.web_issue_order,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 检测固件新版本
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_firmware_info = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_firmware_info,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 下发升级固件指令
 * @param data
 * @returns {*|{responseURL}}
 */
export const upup_firmware = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.upup_firmware,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除字典
 * @param data
 * @returns {*|{responseURL}}
 */
export const dict_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

//
/**
 * 取消分配
 * @param data
 * @returns {*|{responseURL}}
 */
export const quxiao_fenpei = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.quxiao_fenpei,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

//
/**
 * 获取token
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_downloadtoken = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_downloadtoken,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

//
/**
 * 导出
 * @param data
 * @returns {*|{responseURL}}
 */
export const daochu = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.daochu,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

//
/**
 * 导入
 * @param data
 * @returns {*|{responseURL}}
 */
export const daoru = data => {
  let country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: jingxiaoshang.daoru,
    data:data,
    method: "post"
  });
};

/**
 * 设置采样频率
 * @param data
 * @returns {*|{responseURL}}
 */
export const config_caiyang_pinglv = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_caiyang_pinglv,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设置逆变器
 * @param data
 * @returns {*|{responseURL}}
 */
export const config_nibianqi = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_nibianqi,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 轨迹信息设备列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const trajectory_did_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.trajectory_did_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取设备当前位置
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_now_lnglat = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_now_lnglat,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 获取容量趋势图
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_rl_trends = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_rl_trends,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取运行趋势图
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_yx_trends = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_yx_trends,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 轨迹信息轨迹
 * @param data
 * @returns {*|{responseURL}}
 */
export const trajectory_did_detail = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.trajectory_did_detail,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 协议新增
 * @param data
 * @returns {*|{responseURL}}
 */
export const protocol_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 协议列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const protocol_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 协议删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const protocol_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 产品新增
 * @param data
 * @returns {*|{responseURL}}
 */
export const product_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 产品列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const product_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 项目密码管理
 * @param data
 * @returns {*|{responseURL}}
 */
export const config_pass = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_pass,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设备密码管理
 * @param data
 * @returns {*|{responseURL}}
 */
export const did_config_pass = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.did_config_pass,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增硬件版本号
 * @param data
 * @returns {*|{responseURL}}
 */
export const hardware_ver_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 硬件版本号列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const hardware_ver_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 产品删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const product_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 硬件版本号编辑
 * @param data
 * @returns {*|{responseURL}}
 */
export const hardware_ver_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 硬件版本号删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const hardware_ver_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增固件版本
 * @param data
 * @returns {*|{responseURL}}
 */
export const addfirmware = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.addfirmware,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 固件版本列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getfirmwarelist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getfirmwarelist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑固件版本
 * @param data
 * @returns {*|{responseURL}}
 */
export const firmware_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.firmware_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 固件版本删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const deletefirmware = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.deletefirmware,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 新增升级规则
 * @param data
 * @returns {*|{responseURL}}
 */
export const addfirmware_rule = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.addfirmware_rule,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 升级规则列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const getfirmware_rulelist = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getfirmware_rulelist,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 编辑升级规则
 * @param data
 * @returns {*|{responseURL}}
 */
export const firmware_ruleupdate = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.firmware_ruleupdate,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const deletefirmware_rule = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.deletefirmware_rule,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const download_file = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.download_file,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */
export const progress_firmware = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.progress_firmware,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 设备下拉相关
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_about = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_about,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导出产测成功设备ID
 * @param data
 * @returns {*|{responseURL}}
 */
export const export_success_did = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.export_success_did,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
